<script setup>
import VuePdfEmbed from "vue-pdf-embed";
import "pdfjs-dist/web/pdf_viewer.css";

const pdfSource = "/Documents/Prezentare PIM Mosnita Noua.pdf";
</script>

<template>
  <v-container class="pdf-container">
    <VuePdfEmbed
      :source="pdfSource"
      annotation-layer
      text-layer
      class="pdf-view"
    />
  </v-container>
</template>

<script>
// import HomeCard from "@/components/HomeCard.vue";

export default {
  name: "PresentationView",
  data() {
    return {
      screenSize: 0,
    };
  },
  components: {
    // HomeCard,
  },
  methods: {
    getAspectRatio() {
      this.screenSize = window.screen.width / window.screen.height;
    },
  },
};
</script>

<style scoped>
.pdf-container {
  display: flex;
  justify-content: center;
  width: 100%;
  overflow-x: hidden;
}

.pdf-view {
  width: 100%;
  max-width: 1000px; /* optional */
  --pdf-page-margin: 0; /* remove gaps */
}

.pdf-view canvas {
  width: 100% !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
}
.textComponent {
  margin: 20px 20px;
}
.textBox {
  text-align: justify;
  margin: 25px 25px;
}
.textImage {
  text-align: right;
  margin: 25px 25px;
  opacity: 50%;
}
.textTitle {
  text-align: center;
  margin: 25px 25px;
}
.textSubtitle {
  color: #999;
}
.v-divider {
  margin: 0px 5%;
}
.moreButton {
  position: absolute;
  margin-left: 10%;
  margin-top: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
}
.aspect-ratio {
  position: relative;
}

.aspect-ratio > * {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.textList {
  text-align: justify;
  margin: 40px;
}
/* Default font size for all screens */
.responsiveFont {
  font-size: 15px;
}

/* Change font size for screens smaller than 768px (tablets) */
@media (max-width: 767px) {
  .responsiveFont {
    font-size: 13px;
  }
}

/* Change font size for screens smaller than 576px (smartphones) */
@media (max-width: 575px) {
  .responsiveFont {
    font-size: 11px;
  }
}
/* For desktop screens */
@media only screen and (min-width: 1200px) {
  .responsiveWidth {
    max-width: 80%;
  }
}

/* For tablet screens */
@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .responsiveWidth {
    max-width: 90%;
  }
}

/* For smartphone screens */
@media only screen and (max-width: 767px) {
  .responsiveWidth {
    max-width: 100%;
  }
}
.noBulletPoints {
  list-style-type: none;
  font-style: italic;
}
.centerList {
  display: flex;
}
</style>
